import angularLocalStorage from 'angular-local-storage';
import restangular from 'restangular';
import uiRouter from '@uirouter/angularjs';
import ConfigurationService from './configuration.service';
import DictionaryService from './dictionary.service';
import NetworkService from './network.service';
import DataService from './data.service';
import NavigationService from './navigation.service';
import ExpertService from './expert.service';
import PostcodeService from './postCode.service';
import ModalService from './modal.service';
import ProductLinkService from './productLink.service';
import Constants from '../constants';

const ExpertFinderServices = angular
  .module('services.expertFinder', [
    uiRouter,
    restangular,
    angularLocalStorage,
    Constants.name
  ])
  .service('ConfigurationService', ConfigurationService)
  .service('DictionaryService', DictionaryService)
  .service('NetworkService', NetworkService)
  .service('DataService', DataService)
  .service('NavigationService', NavigationService)
  .service('ExpertService', ExpertService)
  .service('ModalService', ModalService)
  .service('PostcodeService', PostcodeService)
  .service('ProductLinkService', ProductLinkService);

export default ExpertFinderServices;



// WEBPACK FOOTER //
// ./src/services/index.js